
import { HttpService } from '@/services/http-service';
import $ from 'jquery';
import uuid from 'uuid/v4';
import { isNull } from './utils/utils';
import { authService } from '@/services/auth-service';

$(document).ajaxSend((event, jqxhr, settings) => {
    const origXhrFunc = settings.xhr

    settings.xhr = () => {
        const xhr = origXhrFunc()
        const origSend = xhr.send

        // tslint:disable-next-line: only-arrow-functions
        xhr.send = function() {
            const origArguments = arguments
            setRequestHeaders(xhr, getRequestHeaders())

            if (xhr.readyState === 1) {
                origSend.apply(xhr, origArguments as any)
            }
        }

        return xhr
    }
})

const getRequestHeaders = (): any => {
    const headers = {
        SessionId: HttpService.SessionId,
        RequestId: uuid(),
    }

    if (!isNull(authService.token)) {
        Object.assign(headers, { Authorization: `Bearer ${authService.token}` })
    }

    return headers
}

const setRequestHeaders = (xhr: XMLHttpRequest, headers: any) => {
    // tslint:disable-next-line: forin
    for (const header in headers) {
        xhr.setRequestHeader(header, headers[header])
    }
}
